/**
 * The address this app was STARTED on.
 *
 * Not the address it is on now, which is what `useLocation` answers. The two are
 * the same only until the first navigation, and the difference between them is a
 * real question: somebody who FOLLOWED A LINK to a car is a newcomer who has
 * never seen the garage, and somebody who walked there from the splash thirty
 * seconds ago has.
 *
 * Recorded from `bootstrap.js` rather than at module scope, because "when this
 * module was first imported" is not a fact anybody controls: it is whenever
 * something in the import graph reached it, which route splitting could quietly
 * change without touching this file. The composition root runs once, before
 * React mounts, and knows it.
 */

let entryPath = '';

export function rememberEntryRoute(pathname) {
    entryPath = String(pathname ?? '');
}

export function entryRoutePath() {
    return entryPath;
}
